import React, { useEffect, useState } from "react";
import "./JobStatus.css";
import OnVacation from "../images/onVacation.png";
import wfh from "../images/wfh.png";
import sickLeave from "../images/sickLeave.png";
import dayOff from "../images/dayOff.png";
import tripB from "../images/tripB.png";
import DOF from "../images/DOF.png";
import WFH from "../images/WFH2.png";
import TopCardPopUp from "./TopCardPopUp";
import { format } from "date-fns";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import axios from "axios";
import { Player } from "@lottiefiles/react-lottie-player";
import expiryAnimation from "../images/insurExp2.png";
import passport_card_image from "../../images/passport_card.svg";
import visa_card_image from "../../images/visa_card_image.svg";
import national_id_image from "../../images/visa_card_image.svg";
import insurance_image from "../../images/insurance_card.svg";
import document_card from "../../images/document_card.svg";
import driving_license from "../../images/driving_license.svg";
import TopCardPopUpExpiryList from "./TopCardPopUpExpiryLsit";
import { FaPassport, FaIdCard, FaRegCreditCard, FaUser } from "react-icons/fa";
import { MdShield, MdDirectionsCar } from "react-icons/md";
import { HiOutlineDocument, HiIdentification } from "react-icons/hi";

const ExpiryCount = () => {
  const [dataFromParent, setDataFromParent] = useState(null);
  const [list_name, setListName] = useState("");

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }
  const [passPortCount, setPassPortCount] = useState(null);
  const [fleetExpiryCount, setFleetExpiryCount] = useState(null);
  const [visaCount, setVisaCount] = useState(null);
  const [nationalIdCount, setNationalIdCount] = useState(null);
  const [personalIdCount, setPersonalIdCount] = useState(null);
  const [insuranceCount, setInsuranceCount] = useState(null);
  const [companyDocsCount, setCompanyDocsCount] = useState(null);
  const [drivingLicenceCount, setDrivingLicenceCount] = useState(null);
  const [birthdayCount, setBirthdayCount] = useState(null);
  const [showJobCardPopUp, setShowJobCardPopUp] = useState(false);
  const [popUpId, setPopUpId] = useState("");
  const [leaveCount, setLeaveCount] = useState(null);

  const [base_url, setBaseUrl] = useState(`${base_url_from_axios_config}/`);

  const openJobCardModal = (id) => {
    setShowJobCardPopUp(true);
    setPopUpId(id);
  };

  const closeJobCardModal = () => {
    setShowJobCardPopUp(false);
    setListName("");
  };

  // Find the Sick Leave count from the API response
  const sickLeaveCount =
    leaveCount?.find((leave) => leave.leave_key === "Sick Leave")?.count || 0;

  const vacationCount =
    leaveCount?.find((leave) => leave.leave_key === "On Vacation")?.count || 0;

  const wfhCount =
    leaveCount?.find((leave) => leave.leave_key === "Work From Home")?.count ||
    0;

  const dayOffCount =
    leaveCount?.find((leave) => leave.leave_key === "Person ID")?.count || 0;

  const businessTripCount =
    leaveCount?.find((leave) => leave.leave_key === "Business Trip")?.count ||
    0;

  useEffect(() => {
    // Format the current date as needed
    const today = format(new Date(), "yyyy-MMM-dd");

    const apiUrl = `${base_url}api/HRDashboard/${companyCode}/-/LEAVECOUNT/${today}/${today}/-/-/-/-/-`;

    // Fetch data from the API
    const fetchLeaveCount = async () => {
      try {
        const response = await axios.get(apiUrl);
        setLeaveCount(response.data);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    if (base_url) {
      fetchLeaveCount();
    }
  }, []);

  useEffect(() => {
    const apiUrlPassport = `${base_url}api/cpayscount/${companyCode}/passport/-/-`;

    // Fetch data from the API
    const callPassportCount = async () => {
      try {
        const response = await axios.get(apiUrlPassport);
        setPassPortCount(response.data[0]?.Cnt);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    const apiUrlFleet = `${base_url}api/cpayscount/${companyCode}/fleet/-/-`;

    // Fetch data from the API
    const callFleetCount = async () => {
      try {
        const response = await axios.get(apiUrlFleet);
        setFleetExpiryCount(response.data[0]?.Cnt);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    const apiUrlVisa = `${base_url}api/cpayscount/${companyCode}/visa/-/-`;

    // Fetch data from the API
    const callVisaCount = async () => {
      try {
        const response = await axios.get(apiUrlVisa);
        setVisaCount(response.data[0]?.Cnt);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    const apiUrlNationalId = `${base_url}api/cpayscount/${companyCode}/nationalid/-/-`;

    // Fetch data from the API
    const callNationalId = async () => {
      try {
        const response = await axios.get(apiUrlNationalId);
        setNationalIdCount(response.data[0]?.Cnt);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    const apiUrlPersonId = `${base_url}api/cpayscount/${companyCode}/personid/-/-`;

    // Fetch data from the API
    const callPersonId = async () => {
      try {
        const response = await axios.get(apiUrlPersonId);
        setPersonalIdCount(response.data[0]?.Cnt);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    const apiUrlInsurance = `${base_url}api/cpayscount/${companyCode}/insurance/-/-`;

    // Fetch data from the API
    const callInsurance = async () => {
      try {
        const response = await axios.get(apiUrlInsurance);
        setInsuranceCount(response.data[0]?.Cnt);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    const apiUrlCompanyDocs = `${base_url}api/cpayscount/${companyCode}/companydocs/-/-`;

    // Fetch data from the API
    const callCompanyDocs = async () => {
      try {
        const response = await axios.get(apiUrlCompanyDocs);
        setCompanyDocsCount(response.data[0]?.Cnt);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    const apiUrlDrivingLic = `${base_url}api/cpayscount/${companyCode}/drivinglic/-/-`;

    // Fetch data from the API
    const callDrivingLic = async () => {
      try {
        const response = await axios.get(apiUrlDrivingLic);
        setDrivingLicenceCount(response.data[0]?.Cnt);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    const apiUrlBirthday = `${base_url}api/cpayscount/${companyCode}/birthday/-/-`;

    // Fetch data from the API
    const callBirthday = async () => {
      try {
        const response = await axios.get(apiUrlBirthday);
        setBirthdayCount(response.data[0]?.Cnt);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    if (base_url) {
      callPassportCount();
      callFleetCount();
      callVisaCount();
      callPersonId();
      callNationalId();
      callInsurance();
      callCompanyDocs();
      callDrivingLic();
      callBirthday();
    }
  }, []);

  const getList = () => {
    const apiUrl = `${base_url}api/CpaysCount/${companyCode}/${list_name}/-/-`;

    console.log("apiUrl explsit - > ", apiUrl);

    axios
      .get(apiUrl)
      .then((res) => {
        setDataFromParent(res.data);
      })
      .catch((ERR) => {});
  };

  useEffect(() => {
    getList();
  }, [list_name]);

  return (
    <>
    
      <div className="flex flex-1  justify-center items-center w-auto ">
        <div className="flex flex-col justify-center items-end w-auto gap-4 ">
          <div className="grid grid-cols-2 gap-1">
            {/* Passport Card */}
            <div
              className="group w-[90px] h-[80px]  group rounded-xl hover:bg-white border   flex flex-col items-center justify-center gap-1 cursor-pointer transition-transform hover:shadow-lg active:scale-95"
              onClick={() => {
                openJobCardModal("Passport Expiry");
                setListName("PASSPORTEXPLIST");
              }}
            >
              <div className=" w-8 h-8 bg-blue-500 rounded-md flex items-center justify-center ">
                {/* <img
                  src={passport_card_image}
                  alt="Passport"
                  className="w-7 h-7 object-contain"
                /> */}
                <FaPassport className="h-4 w-4  text-white group-hover:animate-bounce" />
              </div>

              {/* File Name */}
              <div className=" text-[10px] text-center font-medium text-[#1E2B3A] px-2 leading-tight">
                Passport  -  {passPortCount || 0}
              </div>
            </div>

            {/* ///////////////////////////// */}
            <div
              className="group rounded-xl hover:bg-white border flex flex-col items-center justify-center gap-2 cursor-pointer transition-transform hover:shadow-lg active:scale-95 w-[90px] h-[80px]"
              onClick={() => {
                openJobCardModal("Fleet Expiry");
                // setListName("FLEETEXPLIST");
                setListName("FLEETLIST");
              }}

              // onClick={() => {
              //   // openJobCardModal("Passport Expiry");
              //   // setListName("PASSPORTEXPLIST");
              //   openJobCardModal("Fleet Expiry");
              //   setListName("FLEET");
              // }}
            >
              {/* Icon */}
              <div className="w-8 h-8 bg-teal-500 rounded-md flex items-center justify-center">
                {/* <img
                  src={driving_license}
                  alt="Fleet"
                  className="w-7 h-7 object-contain"
                /> */}
                <MdDirectionsCar className="h-4 w-4 text-white  group-hover:animate-bounce " />
              </div>

              {/* Title & Count */}
              <div className=" text-[10px] text-center font-medium text-[#1E2B3A] px-2 leading-tight">
                {/* Fleet Expiry  -  {passPortCount || 0} */}
                Fleet Expiry  -  {fleetExpiryCount || 0}
              </div>
            </div>

            {/* //////////////////////////////////////// */}
            <div
              className="w-[90px] h-[80px]  group rounded-xl hover:bg-white border flex flex-col items-center justify-center gap-2 cursor-pointer transition-transform hover:shadow-lg active:scale-95  "
              onClick={() => {
                openJobCardModal("Driving License Expiry");
                setListName("DRIVINGLICEXPLIST");
              }}
            >
              {/* Icon */}
              <div className="w-8 h-8 bg-yellow-500 rounded-md flex items-center justify-center">
                {/* <img
                  src={driving_license}
                  alt="Driving License"
                  className="w-7 h-7 object-contain"
                /> */}
                <FaIdCard className="h-4 w-4  text-white group-hover:animate-bounce" />
              </div>

              {/* Title & Count */}
              <div className="text-[10px] text-center font-medium text-[#1E2B3A] px-2 leading-tight">
                License  -  {drivingLicenceCount || 0}
              </div>
            </div>

            {/* //////////////////////////////////////// */}
            <div
              className="w-[90px] h-[80px]  group rounded-xl hover:bg-white border flex flex-col items-center justify-center gap-2 cursor-pointer transition-transform hover:shadow-lg active:scale-95  "
              onClick={() => {
                openJobCardModal("Visa Expiry");
                setListName("VISAEXPLIST");
              }}
            >
              {/* Icon */}
              <div className="w-8 h-8 bg-green-500 rounded-md flex items-center justify-center">
                {/* <img
                  src={visa_card_image}
                  alt="visa_card_image"
                  className="w-7 h-7 object-contain"
                /> */}
                <FaRegCreditCard className="h-4 w-4  text-white group-hover:animate-bounce" />
              </div>

              {/* Title & Count */}
              <div className=" text-[10px] text-center font-medium text-[#1E2B3A] px-2 leading-tight">
                Visa  -  {visaCount || 0}
              </div>
            </div>

            {/* //////////////////////////////////////// */}
            <div
              className="w-[90px] h-[80px]  group rounded-xl hover:bg-white border flex flex-col items-center justify-center gap-2 cursor-pointer transition-transform hover:shadow-lg active:scale-95  "
              onClick={() => {
                openJobCardModal("Insurance Expiry");
                setListName("INSURANCEEXPLIST");
              }}
            >
              {/* Icon */}
              <div className="w-8 h-8 bg-red-500 rounded-md flex items-center justify-center">
                {/* <img
                  src={insurance_image}
                  alt="insurance_image"
                  className="w-7 h-7 object-contain"
                /> */}
                <MdShield className="h-4 w-4  text-white group-hover:animate-bounce" />
              </div>

              {/* Title & Count */}
              <div className=" text-[10px] text-center font-medium text-[#1E2B3A] px-2 leading-tight">
                Insurance  -  {insuranceCount || 0}
              </div>
            </div>

            {/* //////////////////////////////////////// */}
            <div
              className="w-[90px] h-[80px]  group rounded-xl hover:bg-white border flex flex-col items-center justify-center gap-2 cursor-pointer transition-transform hover:shadow-lg active:scale-95  "
              onClick={() => {
                openJobCardModal("National ID Expiry");
                setListName("NATIONALIDEXPLIST");
              }}
            >
              {/* Icon */}
              <div className="w-8 h-8 bg-pink-500 rounded-md flex items-center justify-center">
                {/* <img
                  src={national_id_image}
                  alt="national_id"
                  className="w-7 h-7 object-contain"
                /> */}
                <HiIdentification className="h-4 w-4  text-white group-hover:animate-bounce" />
              </div>

              {/* Title & Count */}
              <div className=" text-[10px] text-center font-medium text-[#1E2B3A] px-2 leading-tight">
                National Id  -  {nationalIdCount || 0}
              </div>
            </div>

            {/* //////////////////////////////////////// */}
            <div
              className="w-[90px] h-[80px]  group rounded-xl hover:bg-white border flex flex-col items-center justify-center gap-2 cursor-pointer transition-transform hover:shadow-lg active:scale-95  "
              onClick={() => {
                openJobCardModal("Company Documents Expiry");
                setListName("COMPANYDOCSEXPLIST");
              }}
            >
              {/* Icon */}
              <div className="w-8 h-8 bg-purple-500 rounded-md flex items-center justify-center">
                {/* <img
                  src={document_card}
                  alt="document_card"
                  className="w-7 h-7 object-contain"
                /> */}
                <HiOutlineDocument className="h-4 w-4  text-white group-hover:animate-bounce" />
              </div>

              {/* Title & Count */}
              <div className=" text-[10px] text-center font-medium text-[#1E2B3A] px-2 leading-tight">
                Documents  -  {companyDocsCount || 0}
              </div>
            </div>

            {/* //////////////////////////////////////// */}
            <div
              className="w-[90px] h-[80px]  group rounded-xl hover:bg-white border flex flex-col items-center justify-center gap-2 cursor-pointer transition-transform hover:shadow-lg active:scale-95  "
              onClick={() => {
                openJobCardModal("Person ID");
                setListName("PERSONIDEXPLIST");
              }}
            >
              {/* Icon */}
              <div className="w-8 h-8 bg-indigo-500 rounded-md flex items-center justify-center">
                {/* <img
                  src={national_id_image}
                  alt="person_id"
                  className="w-7 h-7 object-contain"
                /> */}
                <FaUser className="h-4 w-4  text-white group-hover:animate-bounce" />
              </div>

              {/* Title & Count */}
              <div className=" text-[10px] text-center font-medium text-[#1E2B3A] px-2 leading-tight">
                Person Id  -  {personalIdCount || 0}
              </div>
            </div>


          </div>
        </div>
      </div>

      {
        <TopCardPopUpExpiryList
          showJobCardPopUp={showJobCardPopUp}
          closeJobCardModal={closeJobCardModal}
          popUpId={popUpId}
          dataFromParent={dataFromParent}
          list_name={list_name}
        />
      }
    </>
  );
};

export default ExpiryCount;
